// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-4"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.5 19V13M16.5 13V5M16.5 13H8.5C7.94772 13 7.5 12.5523 7.5 12V5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers4Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-4',
    ref,
    icon: element,
  },
));

Numbers4Icon.displayName = 'Numbers4Icon';

export default Numbers4Icon;
